import { connect } from 'react-redux';
import { stopVideo } from '../../actions/ui';
import VideoOverlay from '../../components/elements/VideoOverlay';

const mapStateToProps = state => ({
    playingVideoLink: state.ui.playingVideo.link,
    playingVideoType: state.ui.playingVideo.type,
});

export default connect(mapStateToProps, {
    stopVideo,
})(VideoOverlay);
